import getScanDatasetFilesForProjectByScanDatasetId from "../../services/getters/file_getters/get_scan_dataset_files_for_project_by_scan_dataset_id";
import loadScanDatasetFilesForProject from "../../actions/react_query/scan_datasets/load_scan_dataset_files_for_project";
import useQueryWithState from "../use_query_with_state";

const useScanDatasetFilesForProject = (projectId: string) => {
  return useQueryWithState(["useScanDatasetFilesForProject", projectId],
    loadScanDatasetFilesForProject,
    getScanDatasetFilesForProjectByScanDatasetId,
    { enabled: !!projectId },
    { projectId },
    projectId);
};

export default useScanDatasetFilesForProject;
